!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports["js-detect-incognito-private-browsing"] = e() : t["js-detect-incognito-private-browsing"] = e();
}("undefined" != typeof self ? self : this, function () {
  return function (t) {
    function e(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return t[n].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }
    var r = {};
    return e.m = t, e.c = r, e.d = function (t, r, n) {
      e.o(t, r) || Object.defineProperty(t, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, e.n = function (t) {
      var r = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return e.d(r, "a", r), r;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 0);
  }([function (t, e, r) {
    r(1), t.exports = r(4);
  }, function (t, e, r) {
    (function (n, o) {
      var i, a;
      !function (n, o) {
        i = o, void 0 !== (a = "function" == typeof i ? i.call(e, r, e, t) : i) && (t.exports = a);
      }(0, function () {
        "use strict";

        var t,
          e = Function.call.bind(Function.apply),
          r = Function.call.bind(Function.call),
          i = Array.isArray,
          a = Object.keys,
          c = function c(t) {
            try {
              return t(), !1;
            } catch (t) {
              return !0;
            }
          },
          u = function u(t) {
            try {
              return t();
            } catch (t) {
              return !1;
            }
          },
          s = function (t) {
            return function () {
              return !e(t, this, arguments);
            };
          }(c),
          f = !!Object.defineProperty && function () {
            return !c(function () {
              Object.defineProperty({}, "x", {
                get: function get() {}
              });
            });
          }(),
          l = "foo" === function () {}.name,
          p = Function.call.bind(Array.prototype.forEach),
          h = Function.call.bind(Array.prototype.reduce),
          y = Function.call.bind(Array.prototype.filter),
          v = Function.call.bind(Array.prototype.some),
          b = function b(t, e, r, n) {
            !n && e in t || (f ? Object.defineProperty(t, e, {
              configurable: !0,
              enumerable: !1,
              writable: !0,
              value: r
            }) : t[e] = r);
          },
          g = function g(t, e, r) {
            p(a(e), function (n) {
              b(t, n, e[n], !!r);
            });
          },
          d = Function.call.bind(Object.prototype.toString),
          w = function w(t) {
            return "function" == typeof t;
          },
          m = {
            getter: function getter(t, e, r) {
              if (!f) throw new TypeError("getters require true ES5 support");
              Object.defineProperty(t, e, {
                configurable: !0,
                enumerable: !1,
                get: r
              });
            },
            proxy: function proxy(t, e, r) {
              if (!f) throw new TypeError("getters require true ES5 support");
              var n = Object.getOwnPropertyDescriptor(t, e);
              Object.defineProperty(r, e, {
                configurable: n.configurable,
                enumerable: n.enumerable,
                get: function get() {
                  return t[e];
                },
                set: function set(r) {
                  t[e] = r;
                }
              });
            },
            redefine: function redefine(t, e, r) {
              if (f) {
                var n = Object.getOwnPropertyDescriptor(t, e);
                n.value = r, Object.defineProperty(t, e, n);
              } else t[e] = r;
            },
            defineByDescriptor: function defineByDescriptor(t, e, r) {
              f ? Object.defineProperty(t, e, r) : "value" in r && (t[e] = r.value);
            },
            preserveToString: function preserveToString(t, e) {
              e && w(e.toString) && b(t, "toString", e.toString.bind(e), !0);
            }
          },
          O = Object.create || function (t, e) {
            var r = function r() {};
            r.prototype = t;
            var n = new r();
            return void 0 !== e && a(e).forEach(function (t) {
              m.defineByDescriptor(n, t, e[t]);
            }), n;
          },
          j = function j(t, e) {
            return !!Object.setPrototypeOf && u(function () {
              var r = function e(r) {
                var n = new t(r);
                return Object.setPrototypeOf(n, e.prototype), n;
              };
              return Object.setPrototypeOf(r, t), r.prototype = O(t.prototype, {
                constructor: {
                  value: r
                }
              }), e(r);
            });
          },
          T = function () {
            if ("undefined" != typeof self) return self;
            if ("undefined" != typeof window) return window;
            if (void 0 !== n) return n;
            throw Error("unable to locate global object");
          }(),
          S = T.isFinite,
          I = Function.call.bind(String.prototype.indexOf),
          E = Function.apply.bind(Array.prototype.indexOf),
          M = Function.call.bind(Array.prototype.concat),
          C = Function.call.bind(String.prototype.slice),
          P = Function.call.bind(Array.prototype.push),
          x = Function.apply.bind(Array.prototype.push),
          _ = Function.call.bind(Array.prototype.shift),
          A = Math.max,
          N = Math.min,
          R = Math.floor,
          k = Math.abs,
          B = Math.exp,
          D = Math.log,
          L = Math.sqrt,
          F = Function.call.bind(Object.prototype.hasOwnProperty),
          z = function z() {},
          G = T.Map,
          q = G && G.prototype.delete,
          W = G && G.prototype.get,
          H = G && G.prototype.has,
          V = G && G.prototype.set,
          U = T.Symbol || {},
          X = U.species || "@@species",
          J = Number.isNaN || function (t) {
            return t !== t;
          },
          Y = Number.isFinite || function (t) {
            return "number" == typeof t && S(t);
          },
          Z = w(Math.sign) ? Math.sign : function (t) {
            var e = +t;
            return 0 === e ? e : J(e) ? e : 0 > e ? -1 : 1;
          },
          K = function K(t) {
            return "[object Arguments]" === d(t);
          },
          Q = function Q(t) {
            return null !== t && "object" == typeof t && "number" == typeof t.length && t.length >= 0 && "[object Array]" !== d(t) && "[object Function]" === d(t.callee);
          },
          tt = K(arguments) ? K : Q,
          et = {
            primitive: function primitive(t) {
              return null === t || "function" != typeof t && "object" != typeof t;
            },
            string: function string(t) {
              return "[object String]" === d(t);
            },
            regex: function regex(t) {
              return "[object RegExp]" === d(t);
            },
            symbol: function symbol(t) {
              return "function" == typeof T.Symbol && "symbol" == typeof t;
            }
          },
          rt = function rt(t, e, r) {
            var n = t[e];
            b(t, e, r, !0), m.preserveToString(t[e], n);
          },
          nt = "function" == typeof U && "function" == typeof U.for && et.symbol(U()),
          ot = et.symbol(U.iterator) ? U.iterator : "_es6-shim iterator_";
        T.Set && "function" == typeof new T.Set()["@@iterator"] && (ot = "@@iterator"), T.Reflect || b(T, "Reflect", {}, !0);
        var it = T.Reflect,
          at = String,
          ct = "undefined" != typeof document && document ? document.all : null,
          ut = null == ct ? function (t) {
            return null == t;
          } : function (t) {
            return null == t && t !== ct;
          },
          st = {
            Call: function Call(t, r) {
              var n = arguments.length > 2 ? arguments[2] : [];
              if (!st.IsCallable(t)) throw new TypeError(t + " is not a function");
              return e(t, r, n);
            },
            RequireObjectCoercible: function RequireObjectCoercible(t, e) {
              if (ut(t)) throw new TypeError(e || "Cannot call method on " + t);
              return t;
            },
            TypeIsObject: function TypeIsObject(t) {
              return void 0 !== t && null !== t && !0 !== t && !1 !== t && ("function" == typeof t || "object" == typeof t || t === ct);
            },
            ToObject: function ToObject(t, e) {
              return Object(st.RequireObjectCoercible(t, e));
            },
            IsCallable: w,
            IsConstructor: function IsConstructor(t) {
              return st.IsCallable(t);
            },
            ToInt32: function ToInt32(t) {
              return st.ToNumber(t) >> 0;
            },
            ToUint32: function ToUint32(t) {
              return st.ToNumber(t) >>> 0;
            },
            ToNumber: function ToNumber(t) {
              if ("[object Symbol]" === d(t)) throw new TypeError("Cannot convert a Symbol value to a number");
              return +t;
            },
            ToInteger: function ToInteger(t) {
              var e = st.ToNumber(t);
              return J(e) ? 0 : 0 !== e && Y(e) ? (e > 0 ? 1 : -1) * R(k(e)) : e;
            },
            ToLength: function ToLength(t) {
              var e = st.ToInteger(t);
              return e > 0 ? e > Number.MAX_SAFE_INTEGER ? Number.MAX_SAFE_INTEGER : e : 0;
            },
            SameValue: function SameValue(t, e) {
              return t === e ? 0 !== t || 1 / t == 1 / e : J(t) && J(e);
            },
            SameValueZero: function SameValueZero(t, e) {
              return t === e || J(t) && J(e);
            },
            IsIterable: function IsIterable(t) {
              return st.TypeIsObject(t) && (void 0 !== t[ot] || tt(t));
            },
            GetIterator: function GetIterator(e) {
              if (tt(e)) return new t(e, "value");
              var r = st.GetMethod(e, ot);
              if (!st.IsCallable(r)) throw new TypeError("value is not an iterable");
              var n = st.Call(r, e);
              if (!st.TypeIsObject(n)) throw new TypeError("bad iterator");
              return n;
            },
            GetMethod: function GetMethod(t, e) {
              var r = st.ToObject(t)[e];
              if (!ut(r)) {
                if (!st.IsCallable(r)) throw new TypeError("Method not callable: " + e);
                return r;
              }
            },
            IteratorComplete: function IteratorComplete(t) {
              return !!t.done;
            },
            IteratorClose: function IteratorClose(t, e) {
              var r = st.GetMethod(t, "return");
              if (void 0 !== r) {
                var n, o;
                try {
                  n = st.Call(r, t);
                } catch (t) {
                  o = t;
                }
                if (!e) {
                  if (o) throw o;
                  if (!st.TypeIsObject(n)) throw new TypeError("Iterator's return method returned a non-object.");
                }
              }
            },
            IteratorNext: function IteratorNext(t) {
              var e = arguments.length > 1 ? t.next(arguments[1]) : t.next();
              if (!st.TypeIsObject(e)) throw new TypeError("bad iterator");
              return e;
            },
            IteratorStep: function IteratorStep(t) {
              var e = st.IteratorNext(t);
              return !st.IteratorComplete(e) && e;
            },
            Construct: function Construct(t, e, r, n) {
              var o = void 0 === r ? t : r;
              if (!n && it.construct) return it.construct(t, e, o);
              var i = o.prototype;
              st.TypeIsObject(i) || (i = Object.prototype);
              var a = O(i),
                c = st.Call(t, a, e);
              return st.TypeIsObject(c) ? c : a;
            },
            SpeciesConstructor: function SpeciesConstructor(t, e) {
              var r = t.constructor;
              if (void 0 === r) return e;
              if (!st.TypeIsObject(r)) throw new TypeError("Bad constructor");
              var n = r[X];
              if (ut(n)) return e;
              if (!st.IsConstructor(n)) throw new TypeError("Bad @@species");
              return n;
            },
            CreateHTML: function CreateHTML(t, e, r, n) {
              var o = st.ToString(t),
                i = "<" + e;
              if ("" !== r) {
                i += " " + r + '="' + st.ToString(n).replace(/"/g, "&quot;") + '"';
              }
              return i + ">" + o + "</" + e + ">";
            },
            IsRegExp: function IsRegExp(t) {
              if (!st.TypeIsObject(t)) return !1;
              var e = t[U.match];
              return void 0 !== e ? !!e : et.regex(t);
            },
            ToString: function ToString(t) {
              return at(t);
            }
          };
        if (f && nt) {
          var ft = function ft(t) {
            if (et.symbol(U[t])) return U[t];
            var e = U.for("Symbol." + t);
            return Object.defineProperty(U, t, {
              configurable: !1,
              enumerable: !1,
              writable: !1,
              value: e
            }), e;
          };
          if (!et.symbol(U.search)) {
            var lt = ft("search"),
              pt = String.prototype.search;
            b(RegExp.prototype, lt, function (t) {
              return st.Call(pt, t, [this]);
            });
            var ht = function ht(t) {
              var e = st.RequireObjectCoercible(this);
              if (!ut(t)) {
                var r = st.GetMethod(t, lt);
                if (void 0 !== r) return st.Call(r, t, [e]);
              }
              return st.Call(pt, e, [st.ToString(t)]);
            };
            rt(String.prototype, "search", ht);
          }
          if (!et.symbol(U.replace)) {
            var yt = ft("replace"),
              vt = String.prototype.replace;
            b(RegExp.prototype, yt, function (t, e) {
              return st.Call(vt, t, [this, e]);
            });
            var bt = function bt(t, e) {
              var r = st.RequireObjectCoercible(this);
              if (!ut(t)) {
                var n = st.GetMethod(t, yt);
                if (void 0 !== n) return st.Call(n, t, [r, e]);
              }
              return st.Call(vt, r, [st.ToString(t), e]);
            };
            rt(String.prototype, "replace", bt);
          }
          if (!et.symbol(U.split)) {
            var gt = ft("split"),
              dt = String.prototype.split;
            b(RegExp.prototype, gt, function (t, e) {
              return st.Call(dt, t, [this, e]);
            });
            var wt = function wt(t, e) {
              var r = st.RequireObjectCoercible(this);
              if (!ut(t)) {
                var n = st.GetMethod(t, gt);
                if (void 0 !== n) return st.Call(n, t, [r, e]);
              }
              return st.Call(dt, r, [st.ToString(t), e]);
            };
            rt(String.prototype, "split", wt);
          }
          var mt = et.symbol(U.match),
            Ot = mt && function () {
              var t = {};
              return t[U.match] = function () {
                return 42;
              }, 42 !== "a".match(t);
            }();
          if (!mt || Ot) {
            var jt = ft("match"),
              Tt = String.prototype.match;
            b(RegExp.prototype, jt, function (t) {
              return st.Call(Tt, t, [this]);
            });
            var St = function St(t) {
              var e = st.RequireObjectCoercible(this);
              if (!ut(t)) {
                var r = st.GetMethod(t, jt);
                if (void 0 !== r) return st.Call(r, t, [e]);
              }
              return st.Call(Tt, e, [st.ToString(t)]);
            };
            rt(String.prototype, "match", St);
          }
        }
        var It = function It(t, e, r) {
            m.preserveToString(e, t), Object.setPrototypeOf && Object.setPrototypeOf(t, e), f ? p(Object.getOwnPropertyNames(t), function (n) {
              n in z || r[n] || m.proxy(t, n, e);
            }) : p(Object.keys(t), function (n) {
              n in z || r[n] || (e[n] = t[n]);
            }), e.prototype = t.prototype, m.redefine(t.prototype, "constructor", e);
          },
          Et = function Et() {
            return this;
          },
          Mt = function Mt(t) {
            f && !F(t, X) && m.getter(t, X, Et);
          },
          Ct = function Ct(t, e) {
            var r = e || function () {
              return this;
            };
            b(t, ot, r), !t[ot] && et.symbol(ot) && (t[ot] = r);
          },
          Pt = function Pt(t, e, r) {
            f ? Object.defineProperty(t, e, {
              configurable: !0,
              enumerable: !0,
              writable: !0,
              value: r
            }) : t[e] = r;
          },
          xt = function xt(t, e, r) {
            if (Pt(t, e, r), !st.SameValue(t[e], r)) throw new TypeError("property is nonconfigurable");
          },
          _t = function _t(t, e, r, n) {
            if (!st.TypeIsObject(t)) throw new TypeError("Constructor requires `new`: " + e.name);
            var o = e.prototype;
            st.TypeIsObject(o) || (o = r);
            var i = O(o);
            for (var a in n) if (F(n, a)) {
              var c = n[a];
              b(i, a, c, !0);
            }
            return i;
          };
        if (String.fromCodePoint && 1 !== String.fromCodePoint.length) {
          var At = String.fromCodePoint;
          rt(String, "fromCodePoint", function (t) {
            return st.Call(At, this, arguments);
          });
        }
        var Nt = {
          fromCodePoint: function fromCodePoint(t) {
            for (var e, r = [], n = 0, o = arguments.length; o > n; n++) {
              if (e = +arguments[n], !st.SameValue(e, st.ToInteger(e)) || 0 > e || e > 1114111) throw new RangeError("Invalid code point " + e);
              65536 > e ? P(r, String.fromCharCode(e)) : (e -= 65536, P(r, String.fromCharCode(55296 + (e >> 10))), P(r, String.fromCharCode(e % 1024 + 56320)));
            }
            return r.join("");
          },
          raw: function raw(t) {
            var e = st.ToObject(t, "bad callSite"),
              r = st.ToObject(e.raw, "bad raw value"),
              n = r.length,
              o = st.ToLength(n);
            if (0 >= o) return "";
            for (var i, a, c, u, s = [], f = 0; o > f && (i = st.ToString(f), c = st.ToString(r[i]), P(s, c), o > f + 1);) a = arguments.length > f + 1 ? arguments[f + 1] : "", u = st.ToString(a), P(s, u), f += 1;
            return s.join("");
          }
        };
        String.raw && "xy" !== String.raw({
          raw: {
            0: "x",
            1: "y",
            length: 2
          }
        }) && rt(String, "raw", Nt.raw), g(String, Nt);
        var Rt = function t(e, r) {
            if (1 > r) return "";
            if (r % 2) return t(e, r - 1) + e;
            var n = t(e, r / 2);
            return n + n;
          },
          kt = {
            repeat: function repeat(t) {
              var e = st.ToString(st.RequireObjectCoercible(this)),
                r = st.ToInteger(t);
              if (0 > r || r >= 1 / 0) throw new RangeError("repeat count must be less than infinity and not overflow maximum string size");
              return Rt(e, r);
            },
            startsWith: function startsWith(t) {
              var e = st.ToString(st.RequireObjectCoercible(this));
              if (st.IsRegExp(t)) throw new TypeError('Cannot call method "startsWith" with a regex');
              var r,
                n = st.ToString(t);
              arguments.length > 1 && (r = arguments[1]);
              var o = A(st.ToInteger(r), 0);
              return C(e, o, o + n.length) === n;
            },
            endsWith: function endsWith(t) {
              var e = st.ToString(st.RequireObjectCoercible(this));
              if (st.IsRegExp(t)) throw new TypeError('Cannot call method "endsWith" with a regex');
              var r,
                n = st.ToString(t),
                o = e.length;
              arguments.length > 1 && (r = arguments[1]);
              var i = void 0 === r ? o : st.ToInteger(r),
                a = N(A(i, 0), o);
              return C(e, a - n.length, a) === n;
            },
            includes: function includes(t) {
              if (st.IsRegExp(t)) throw new TypeError('"includes" does not accept a RegExp');
              var e,
                r = st.ToString(t);
              return arguments.length > 1 && (e = arguments[1]), -1 !== I(this, r, e);
            },
            codePointAt: function codePointAt(t) {
              var e = st.ToString(st.RequireObjectCoercible(this)),
                r = st.ToInteger(t),
                n = e.length;
              if (r >= 0 && n > r) {
                var o = e.charCodeAt(r),
                  i = r + 1 === n;
                if (55296 > o || o > 56319 || i) return o;
                var a = e.charCodeAt(r + 1);
                return 56320 > a || a > 57343 ? o : 1024 * (o - 55296) + (a - 56320) + 65536;
              }
            }
          };
        if (String.prototype.includes && !1 !== "a".includes("a", 1 / 0) && rt(String.prototype, "includes", kt.includes), String.prototype.startsWith && String.prototype.endsWith) {
          var Bt = c(function () {
              "/a/".startsWith(/a/);
            }),
            Dt = u(function () {
              return !1 === "abc".startsWith("a", 1 / 0);
            });
          Bt && Dt || (rt(String.prototype, "startsWith", kt.startsWith), rt(String.prototype, "endsWith", kt.endsWith));
        }
        if (nt) {
          u(function () {
            var t = /a/;
            return t[U.match] = !1, "/a/".startsWith(t);
          }) || rt(String.prototype, "startsWith", kt.startsWith);
          u(function () {
            var t = /a/;
            return t[U.match] = !1, "/a/".endsWith(t);
          }) || rt(String.prototype, "endsWith", kt.endsWith);
          u(function () {
            var t = /a/;
            return t[U.match] = !1, "/a/".includes(t);
          }) || rt(String.prototype, "includes", kt.includes);
        }
        g(String.prototype, kt);
        var Lt = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF",
          Ft = RegExp("(^[" + Lt + "]+)|([" + Lt + "]+$)", "g"),
          zt = function zt() {
            return st.ToString(st.RequireObjectCoercible(this)).replace(Ft, "");
          },
          Gt = "​￾",
          qt = RegExp("[" + Gt + "]", "g"),
          Wt = /^[-+]0x[0-9a-f]+$/i,
          Ht = Gt.trim().length !== Gt.length;
        b(String.prototype, "trim", zt, Ht);
        var Vt = function Vt(t) {
            return {
              value: t,
              done: 0 === arguments.length
            };
          },
          Ut = function Ut(t) {
            st.RequireObjectCoercible(t), this._s = st.ToString(t), this._i = 0;
          };
        Ut.prototype.next = function () {
          var t = this._s,
            e = this._i;
          if (void 0 === t || e >= t.length) return this._s = void 0, Vt();
          var r,
            n,
            o = t.charCodeAt(e);
          return 55296 > o || o > 56319 || e + 1 === t.length ? n = 1 : (r = t.charCodeAt(e + 1), n = 56320 > r || r > 57343 ? 1 : 2), this._i = e + n, Vt(t.substr(e, n));
        }, Ct(Ut.prototype), Ct(String.prototype, function () {
          return new Ut(this);
        });
        var $t = {
          from: function from(t) {
            var e,
              n = this;
            arguments.length > 1 && (e = arguments[1]);
            var o, i;
            if (void 0 === e) o = !1;else {
              if (!st.IsCallable(e)) throw new TypeError("Array.from: when provided, the second argument must be a function");
              arguments.length > 2 && (i = arguments[2]), o = !0;
            }
            var a,
              c,
              u,
              s = void 0 !== (tt(t) || st.GetMethod(t, ot));
            if (s) {
              c = st.IsConstructor(n) ? Object(new n()) : [];
              var f,
                l,
                p = st.GetIterator(t);
              for (u = 0;;) {
                if (!1 === (f = st.IteratorStep(p))) break;
                l = f.value;
                try {
                  o && (l = void 0 === i ? e(l, u) : r(e, i, l, u)), c[u] = l;
                } catch (t) {
                  throw st.IteratorClose(p, !0), t;
                }
                u += 1;
              }
              a = u;
            } else {
              var h = st.ToObject(t);
              a = st.ToLength(h.length), c = st.IsConstructor(n) ? Object(new n(a)) : Array(a);
              var y;
              for (u = 0; a > u; ++u) y = h[u], o && (y = void 0 === i ? e(y, u) : r(e, i, y, u)), xt(c, u, y);
            }
            return c.length = a, c;
          },
          of: function of() {
            for (var t = arguments.length, e = this, r = i(e) || !st.IsCallable(e) ? Array(t) : st.Construct(e, [t]), n = 0; t > n; ++n) xt(r, n, arguments[n]);
            return r.length = t, r;
          }
        };
        g(Array, $t), Mt(Array), t = function t(_t2, e) {
          this.i = 0, this.array = _t2, this.kind = e;
        }, g(t.prototype, {
          next: function next() {
            var e = this.i,
              r = this.array;
            if (!(this instanceof t)) throw new TypeError("Not an ArrayIterator");
            if (void 0 !== r) for (var n = st.ToLength(r.length); n > e; e++) {
              var o,
                i = this.kind;
              return "key" === i ? o = e : "value" === i ? o = r[e] : "entry" === i && (o = [e, r[e]]), this.i = e + 1, Vt(o);
            }
            return this.array = void 0, Vt();
          }
        }), Ct(t.prototype), Array.of === $t.of || function () {
          var t = function t(_t3) {
            this.length = _t3;
          };
          t.prototype = [];
          var e = Array.of.apply(t, [1, 2]);
          return e instanceof t && 2 === e.length;
        }() || rt(Array, "of", $t.of);
        var Xt = {
          copyWithin: function copyWithin(t, e) {
            var r,
              n = st.ToObject(this),
              o = st.ToLength(n.length),
              i = st.ToInteger(t),
              a = st.ToInteger(e),
              c = 0 > i ? A(o + i, 0) : N(i, o),
              u = 0 > a ? A(o + a, 0) : N(a, o);
            arguments.length > 2 && (r = arguments[2]);
            var s = void 0 === r ? o : st.ToInteger(r),
              f = 0 > s ? A(o + s, 0) : N(s, o),
              l = N(f - u, o - c),
              p = 1;
            for (c > u && u + l > c && (p = -1, u += l - 1, c += l - 1); l > 0;) u in n ? n[c] = n[u] : delete n[c], u += p, c += p, l -= 1;
            return n;
          },
          fill: function fill(t) {
            var e;
            arguments.length > 1 && (e = arguments[1]);
            var r;
            arguments.length > 2 && (r = arguments[2]);
            var n = st.ToObject(this),
              o = st.ToLength(n.length);
            e = st.ToInteger(void 0 === e ? 0 : e), r = st.ToInteger(void 0 === r ? o : r);
            for (var i = 0 > e ? A(o + e, 0) : N(e, o), a = 0 > r ? o + r : r, c = i; o > c && a > c; ++c) n[c] = t;
            return n;
          },
          find: function find(t) {
            var e = st.ToObject(this),
              n = st.ToLength(e.length);
            if (!st.IsCallable(t)) throw new TypeError("Array#find: predicate must be a function");
            for (var o, i = arguments.length > 1 ? arguments[1] : null, a = 0; n > a; a++) if (o = e[a], i) {
              if (r(t, i, o, a, e)) return o;
            } else if (t(o, a, e)) return o;
          },
          findIndex: function findIndex(t) {
            var e = st.ToObject(this),
              n = st.ToLength(e.length);
            if (!st.IsCallable(t)) throw new TypeError("Array#findIndex: predicate must be a function");
            for (var o = arguments.length > 1 ? arguments[1] : null, i = 0; n > i; i++) if (o) {
              if (r(t, o, e[i], i, e)) return i;
            } else if (t(e[i], i, e)) return i;
            return -1;
          },
          keys: function keys() {
            return new t(this, "key");
          },
          values: function values() {
            return new t(this, "value");
          },
          entries: function entries() {
            return new t(this, "entry");
          }
        };
        if (Array.prototype.keys && !st.IsCallable([1].keys().next) && delete Array.prototype.keys, Array.prototype.entries && !st.IsCallable([1].entries().next) && delete Array.prototype.entries, Array.prototype.keys && Array.prototype.entries && !Array.prototype.values && Array.prototype[ot] && (g(Array.prototype, {
          values: Array.prototype[ot]
        }), et.symbol(U.unscopables) && (Array.prototype[U.unscopables].values = !0)), l && Array.prototype.values && "values" !== Array.prototype.values.name) {
          var Jt = Array.prototype.values;
          rt(Array.prototype, "values", function () {
            return st.Call(Jt, this, arguments);
          }), b(Array.prototype, ot, Array.prototype.values, !0);
        }
        g(Array.prototype, Xt), 0 > 1 / [!0].indexOf(!0, -0) && b(Array.prototype, "indexOf", function (t) {
          var e = E(this, arguments);
          return 0 === e && 0 > 1 / e ? 0 : e;
        }, !0), Ct(Array.prototype, function () {
          return this.values();
        }), Object.getPrototypeOf && Ct(Object.getPrototypeOf([].values()));
        var Yt = function () {
            return u(function () {
              return 0 === Array.from({
                length: -1
              }).length;
            });
          }(),
          Zt = function () {
            var t = Array.from([0].entries());
            return 1 === t.length && i(t[0]) && 0 === t[0][0] && 0 === t[0][1];
          }();
        if (Yt && Zt || rt(Array, "from", $t.from), !function () {
          return u(function () {
            return Array.from([0], void 0);
          });
        }()) {
          var Kt = Array.from;
          rt(Array, "from", function (t) {
            return arguments.length > 1 && void 0 !== arguments[1] ? st.Call(Kt, this, arguments) : r(Kt, this, t);
          });
        }
        var Qt = -(Math.pow(2, 32) - 1),
          te = function te(t, e) {
            var n = {
              length: Qt
            };
            return n[e ? (n.length >>> 0) - 1 : 0] = !0, u(function () {
              return r(t, n, function () {
                throw new RangeError("should not reach here");
              }, []), !0;
            });
          };
        if (!te(Array.prototype.forEach)) {
          var ee = Array.prototype.forEach;
          rt(Array.prototype, "forEach", function (t) {
            return st.Call(ee, 0 > this.length ? [] : this, arguments);
          });
        }
        if (!te(Array.prototype.map)) {
          var re = Array.prototype.map;
          rt(Array.prototype, "map", function (t) {
            return st.Call(re, 0 > this.length ? [] : this, arguments);
          });
        }
        if (!te(Array.prototype.filter)) {
          var ne = Array.prototype.filter;
          rt(Array.prototype, "filter", function (t) {
            return st.Call(ne, 0 > this.length ? [] : this, arguments);
          });
        }
        if (!te(Array.prototype.some)) {
          var oe = Array.prototype.some;
          rt(Array.prototype, "some", function (t) {
            return st.Call(oe, 0 > this.length ? [] : this, arguments);
          });
        }
        if (!te(Array.prototype.every)) {
          var ie = Array.prototype.every;
          rt(Array.prototype, "every", function (t) {
            return st.Call(ie, 0 > this.length ? [] : this, arguments);
          });
        }
        if (!te(Array.prototype.reduce)) {
          var ae = Array.prototype.reduce;
          rt(Array.prototype, "reduce", function (t) {
            return st.Call(ae, 0 > this.length ? [] : this, arguments);
          });
        }
        if (!te(Array.prototype.reduceRight, !0)) {
          var ce = Array.prototype.reduceRight;
          rt(Array.prototype, "reduceRight", function (t) {
            return st.Call(ce, 0 > this.length ? [] : this, arguments);
          });
        }
        if (v(Gt, function (t) {
          return 0 == +(t + 0 + t);
        })) {
          var ue = Number,
            se = /^0b[01]+$/i,
            fe = /^0o[0-7]+$/i,
            le = se.test.bind(se),
            pe = fe.test.bind(fe),
            he = function he(t) {
              var e;
              if ("function" == typeof t.valueOf && (e = t.valueOf(), et.primitive(e))) return e;
              if ("function" == typeof t.toString && (e = "" + t, et.primitive(e))) return e;
              throw new TypeError("No default value");
            },
            ye = qt.test.bind(qt),
            ve = Wt.test.bind(Wt),
            be = function () {
              var _t4 = function t(e) {
                var r;
                "string" == typeof (r = arguments.length > 0 ? et.primitive(e) ? e : he(e) : 0) && (r = st.Call(zt, r), le(r) ? r = parseInt(C(r, 2), 2) : pe(r) ? r = parseInt(C(r, 2), 8) : (ye(r) || ve(r)) && (r = NaN));
                var n = this,
                  o = u(function () {
                    return ue.prototype.valueOf.call(n), !0;
                  });
                return n instanceof _t4 && !o ? new ue(r) : ue(r);
              };
              return _t4;
            }();
          It(ue, be, {}), g(be, {
            NaN: ue.NaN,
            MAX_VALUE: ue.MAX_VALUE,
            MIN_VALUE: ue.MIN_VALUE,
            NEGATIVE_INFINITY: ue.NEGATIVE_INFINITY,
            POSITIVE_INFINITY: ue.POSITIVE_INFINITY
          }), Number = be, m.redefine(T, "Number", be);
        }
        var ge = Math.pow(2, 53) - 1;
        g(Number, {
          MAX_SAFE_INTEGER: ge,
          MIN_SAFE_INTEGER: -ge,
          EPSILON: 2.220446049250313e-16,
          parseInt: T.parseInt,
          parseFloat: T.parseFloat,
          isFinite: Y,
          isInteger: function isInteger(t) {
            return Y(t) && st.ToInteger(t) === t;
          },
          isSafeInteger: function isSafeInteger(t) {
            return Number.isInteger(t) && k(t) <= Number.MAX_SAFE_INTEGER;
          },
          isNaN: J
        }), b(Number, "parseInt", T.parseInt, Number.parseInt !== T.parseInt), 1 === [, 1].find(function () {
          return !0;
        }) && rt(Array.prototype, "find", Xt.find), 0 !== [, 1].findIndex(function () {
          return !0;
        }) && rt(Array.prototype, "findIndex", Xt.findIndex);
        var de = Function.bind.call(Function.bind, Object.prototype.propertyIsEnumerable),
          we = function we(t, e) {
            f && de(t, e) && Object.defineProperty(t, e, {
              enumerable: !1
            });
          },
          me = function me() {
            for (var t = +this, e = arguments.length, r = e - t, n = Array(0 > r ? 0 : r), o = t; e > o; ++o) n[o - t] = arguments[o];
            return n;
          },
          Oe = function Oe(t) {
            return function (e, r) {
              return e[r] = t[r], e;
            };
          },
          je = function je(t, e) {
            var r,
              n = a(Object(e));
            return st.IsCallable(Object.getOwnPropertySymbols) && (r = y(Object.getOwnPropertySymbols(Object(e)), de(e))), h(M(n, r || []), Oe(e), t);
          },
          Te = {
            assign: function assign(t, e) {
              var r = st.ToObject(t, "Cannot convert undefined or null to object");
              return h(st.Call(me, 1, arguments), je, r);
            },
            is: function is(t, e) {
              return st.SameValue(t, e);
            }
          };
        if (Object.assign && Object.preventExtensions && function () {
          var t = Object.preventExtensions({
            1: 2
          });
          try {
            Object.assign(t, "xy");
          } catch (e) {
            return "y" === t[1];
          }
        }() && rt(Object, "assign", Te.assign), g(Object, Te), f) {
          var Se = {
            setPrototypeOf: function (t, e) {
              var n,
                o = function o(t, e) {
                  if (!st.TypeIsObject(t)) throw new TypeError("cannot set prototype on a non-object");
                  if (null !== e && !st.TypeIsObject(e)) throw new TypeError("can only set prototype to an object or null" + e);
                },
                i = function i(t, e) {
                  return o(t, e), r(n, t, e), t;
                };
              try {
                n = t.getOwnPropertyDescriptor(t.prototype, "__proto__").set, r(n, {}, null);
              } catch (e) {
                if (t.prototype !== {}.__proto__) return;
                n = function n(t) {
                  this.__proto__ = t;
                }, i.polyfill = i(i({}, null), t.prototype) instanceof t;
              }
              return i;
            }(Object)
          };
          g(Object, Se);
        }
        if (Object.setPrototypeOf && Object.getPrototypeOf && null !== Object.getPrototypeOf(Object.setPrototypeOf({}, null)) && null === Object.getPrototypeOf(Object.create(null)) && function () {
          var t = Object.create(null),
            e = Object.getPrototypeOf,
            r = Object.setPrototypeOf;
          Object.getPrototypeOf = function (r) {
            var n = e(r);
            return n === t ? null : n;
          }, Object.setPrototypeOf = function (e, n) {
            return r(e, null === n ? t : n);
          }, Object.setPrototypeOf.polyfill = !1;
        }(), !!c(function () {
          Object.keys("foo");
        })) {
          var Ie = Object.keys;
          rt(Object, "keys", function (t) {
            return Ie(st.ToObject(t));
          }), a = Object.keys;
        }
        if (c(function () {
          Object.keys(/a/g);
        })) {
          var Ee = Object.keys;
          rt(Object, "keys", function (t) {
            if (et.regex(t)) {
              var e = [];
              for (var r in t) F(t, r) && P(e, r);
              return e;
            }
            return Ee(t);
          }), a = Object.keys;
        }
        if (Object.getOwnPropertyNames) {
          if (!!c(function () {
            Object.getOwnPropertyNames("foo");
          })) {
            var Me = "object" == typeof window ? Object.getOwnPropertyNames(window) : [],
              Ce = Object.getOwnPropertyNames;
            rt(Object, "getOwnPropertyNames", function (t) {
              var e = st.ToObject(t);
              if ("[object Window]" === d(e)) try {
                return Ce(e);
              } catch (t) {
                return M([], Me);
              }
              return Ce(e);
            });
          }
        }
        if (Object.getOwnPropertyDescriptor) {
          if (!!c(function () {
            Object.getOwnPropertyDescriptor("foo", "bar");
          })) {
            var Pe = Object.getOwnPropertyDescriptor;
            rt(Object, "getOwnPropertyDescriptor", function (t, e) {
              return Pe(st.ToObject(t), e);
            });
          }
        }
        if (Object.seal) {
          if (!!c(function () {
            Object.seal("foo");
          })) {
            var xe = Object.seal;
            rt(Object, "seal", function (t) {
              return st.TypeIsObject(t) ? xe(t) : t;
            });
          }
        }
        if (Object.isSealed) {
          if (!!c(function () {
            Object.isSealed("foo");
          })) {
            var _e = Object.isSealed;
            rt(Object, "isSealed", function (t) {
              return !st.TypeIsObject(t) || _e(t);
            });
          }
        }
        if (Object.freeze) {
          if (!!c(function () {
            Object.freeze("foo");
          })) {
            var Ae = Object.freeze;
            rt(Object, "freeze", function (t) {
              return st.TypeIsObject(t) ? Ae(t) : t;
            });
          }
        }
        if (Object.isFrozen) {
          if (!!c(function () {
            Object.isFrozen("foo");
          })) {
            var Ne = Object.isFrozen;
            rt(Object, "isFrozen", function (t) {
              return !st.TypeIsObject(t) || Ne(t);
            });
          }
        }
        if (Object.preventExtensions) {
          if (!!c(function () {
            Object.preventExtensions("foo");
          })) {
            var Re = Object.preventExtensions;
            rt(Object, "preventExtensions", function (t) {
              return st.TypeIsObject(t) ? Re(t) : t;
            });
          }
        }
        if (Object.isExtensible) {
          if (!!c(function () {
            Object.isExtensible("foo");
          })) {
            var ke = Object.isExtensible;
            rt(Object, "isExtensible", function (t) {
              return !!st.TypeIsObject(t) && ke(t);
            });
          }
        }
        if (Object.getPrototypeOf) {
          if (!!c(function () {
            Object.getPrototypeOf("foo");
          })) {
            var Be = Object.getPrototypeOf;
            rt(Object, "getPrototypeOf", function (t) {
              return Be(st.ToObject(t));
            });
          }
        }
        var De = f && function () {
          var t = Object.getOwnPropertyDescriptor(RegExp.prototype, "flags");
          return t && st.IsCallable(t.get);
        }();
        if (f && !De) {
          var Le = function Le() {
            if (!st.TypeIsObject(this)) throw new TypeError("Method called on incompatible type: must be an object.");
            var t = "";
            return this.global && (t += "g"), this.ignoreCase && (t += "i"), this.multiline && (t += "m"), this.unicode && (t += "u"), this.sticky && (t += "y"), t;
          };
          m.getter(RegExp.prototype, "flags", Le);
        }
        var Fe = f && u(function () {
            return RegExp(/a/g, "i") + "" == "/a/i";
          }),
          ze = nt && f && function () {
            var t = /./;
            return t[U.match] = !1, RegExp(t) === t;
          }(),
          Ge = u(function () {
            return "/abc/" === RegExp.prototype.toString.call({
              source: "abc"
            });
          }),
          qe = Ge && u(function () {
            return "/a/b" === RegExp.prototype.toString.call({
              source: "a",
              flags: "b"
            });
          });
        if (!Ge || !qe) {
          var We = RegExp.prototype.toString;
          b(RegExp.prototype, "toString", function () {
            var t = st.RequireObjectCoercible(this);
            return et.regex(t) ? r(We, t) : "/" + at(t.source) + "/" + at(t.flags);
          }, !0), m.preserveToString(RegExp.prototype.toString, We);
        }
        if (f && (!Fe || ze)) {
          var He = Object.getOwnPropertyDescriptor(RegExp.prototype, "flags").get,
            Ve = Object.getOwnPropertyDescriptor(RegExp.prototype, "source") || {},
            Ue = function Ue() {
              return this.source;
            },
            $e = st.IsCallable(Ve.get) ? Ve.get : Ue,
            Xe = RegExp,
            Je = function () {
              return function t(e, r) {
                var n = st.IsRegExp(e);
                if (!(this instanceof t) && n && void 0 === r && e.constructor === t) return e;
                var o = e,
                  i = r;
                return et.regex(e) ? (o = st.Call($e, e), i = void 0 === r ? st.Call(He, e) : r, new t(o, i)) : (n && (o = e.source, i = void 0 === r ? e.flags : r), new Xe(e, r));
              };
            }();
          It(Xe, Je, {
            $input: !0
          }), RegExp = Je, m.redefine(T, "RegExp", Je);
        }
        if (f) {
          var Ye = {
            input: "$_",
            lastMatch: "$&",
            lastParen: "$+",
            leftContext: "$`",
            rightContext: "$'"
          };
          p(a(Ye), function (t) {
            t in RegExp && !(Ye[t] in RegExp) && m.getter(RegExp, Ye[t], function () {
              return RegExp[t];
            });
          });
        }
        Mt(RegExp);
        var Ze = 1 / Number.EPSILON,
          Ke = function Ke(t) {
            return t + Ze - Ze;
          },
          Qe = Math.pow(2, -23),
          tr = Math.pow(2, 127) * (2 - Qe),
          er = Math.pow(2, -126),
          rr = Math.E,
          nr = Math.LOG2E,
          or = Math.LOG10E,
          ir = Number.prototype.clz;
        delete Number.prototype.clz;
        var ar = {
          acosh: function acosh(t) {
            var e = +t;
            return J(e) || 1 > t ? NaN : 1 === e ? 0 : e === 1 / 0 ? e : D(e / rr + L(e + 1) * L(e - 1) / rr) + 1;
          },
          asinh: function t(e) {
            var r = +e;
            return 0 !== r && S(r) ? 0 > r ? -t(-r) : D(r + L(r * r + 1)) : r;
          },
          atanh: function atanh(t) {
            var e = +t;
            return J(e) || -1 > e || e > 1 ? NaN : -1 === e ? -1 / 0 : 1 === e ? 1 / 0 : 0 === e ? e : .5 * D((1 + e) / (1 - e));
          },
          cbrt: function cbrt(t) {
            var e = +t;
            if (0 === e) return e;
            var r,
              n = 0 > e;
            return n && (e = -e), e === 1 / 0 ? r = 1 / 0 : (r = B(D(e) / 3), r = (e / (r * r) + 2 * r) / 3), n ? -r : r;
          },
          clz32: function clz32(t) {
            var e = +t,
              r = st.ToUint32(e);
            return 0 === r ? 32 : ir ? st.Call(ir, r) : 31 - R(D(r + .5) * nr);
          },
          cosh: function cosh(t) {
            var e = +t;
            return 0 === e ? 1 : J(e) ? NaN : S(e) ? (0 > e && (e = -e), e > 21 ? B(e) / 2 : (B(e) + B(-e)) / 2) : 1 / 0;
          },
          expm1: function expm1(t) {
            var e = +t;
            if (e === -1 / 0) return -1;
            if (!S(e) || 0 === e) return e;
            if (k(e) > .5) return B(e) - 1;
            for (var r = e, n = 0, o = 1; n + r !== n;) n += r, o += 1, r *= e / o;
            return n;
          },
          hypot: function hypot(t, e) {
            for (var r = 0, n = 0, o = 0; arguments.length > o; ++o) {
              var i = k(+arguments[o]);
              i > n ? (r *= n / i * (n / i), r += 1, n = i) : r += i > 0 ? i / n * (i / n) : i;
            }
            return n === 1 / 0 ? 1 / 0 : n * L(r);
          },
          log2: function log2(t) {
            return D(t) * nr;
          },
          log10: function log10(t) {
            return D(t) * or;
          },
          log1p: function log1p(t) {
            var e = +t;
            return -1 > e || J(e) ? NaN : 0 === e || e === 1 / 0 ? e : -1 === e ? -1 / 0 : 1 + e - 1 == 0 ? e : e * (D(1 + e) / (1 + e - 1));
          },
          sign: Z,
          sinh: function sinh(t) {
            var e = +t;
            return S(e) && 0 !== e ? 1 > k(e) ? (Math.expm1(e) - Math.expm1(-e)) / 2 : (B(e - 1) - B(-e - 1)) * rr / 2 : e;
          },
          tanh: function tanh(t) {
            var e = +t;
            return J(e) || 0 === e ? e : 20 > e ? e > -20 ? (Math.expm1(e) - Math.expm1(-e)) / (B(e) + B(-e)) : -1 : 1;
          },
          trunc: function trunc(t) {
            var e = +t;
            return 0 > e ? -R(-e) : R(e);
          },
          imul: function imul(t, e) {
            var r = st.ToUint32(t),
              n = st.ToUint32(e),
              o = r >>> 16 & 65535,
              i = 65535 & r,
              a = n >>> 16 & 65535,
              c = 65535 & n;
            return i * c + (o * c + i * a << 16 >>> 0) | 0;
          },
          fround: function fround(t) {
            var e = +t;
            if (0 === e || e === 1 / 0 || e === -1 / 0 || J(e)) return e;
            var r = Z(e),
              n = k(e);
            if (er > n) return r * Ke(n / er / Qe) * er * Qe;
            var o = (1 + Qe / Number.EPSILON) * n,
              i = o - (o - n);
            return i > tr || J(i) ? r * (1 / 0) : r * i;
          }
        };
        g(Math, ar), b(Math, "log1p", ar.log1p, -1e-17 !== Math.log1p(-1e-17)), b(Math, "asinh", ar.asinh, Math.asinh(-1e7) !== -Math.asinh(1e7)), b(Math, "tanh", ar.tanh, -2e-17 !== Math.tanh(-2e-17)), b(Math, "acosh", ar.acosh, Math.acosh(Number.MAX_VALUE) === 1 / 0), b(Math, "cbrt", ar.cbrt, Math.abs(1 - Math.cbrt(1e-300) / 1e-100) / Number.EPSILON > 8), b(Math, "sinh", ar.sinh, -2e-17 !== Math.sinh(-2e-17));
        var cr = Math.expm1(10);
        b(Math, "expm1", ar.expm1, cr > 22025.465794806718 || 22025.465794806718 > cr);
        var ur = Math.round,
          sr = 0 === Math.round(.5 - Number.EPSILON / 4) && 1 === Math.round(Number.EPSILON / 3.99 - .5),
          fr = Ze + 1,
          lr = 2 * Ze - 1,
          pr = [fr, lr].every(function (t) {
            return Math.round(t) === t;
          });
        b(Math, "round", function (t) {
          var e = R(t),
            r = -1 === e ? -0 : e + 1;
          return .5 > t - e ? e : r;
        }, !sr || !pr), m.preserveToString(Math.round, ur);
        var hr = Math.imul;
        -5 !== Math.imul(4294967295, 5) && (Math.imul = ar.imul, m.preserveToString(Math.imul, hr)), 2 !== Math.imul.length && rt(Math, "imul", function (t, e) {
          return st.Call(hr, Math, arguments);
        });
        var yr = function () {
          var t = T.setTimeout;
          if ("function" == typeof t || "object" == typeof t) {
            st.IsPromise = function (t) {
              return !!st.TypeIsObject(t) && void 0 !== t._promise;
            };
            var e,
              n = function n(t) {
                if (!st.IsConstructor(t)) throw new TypeError("Bad promise constructor");
                var e = this,
                  r = function r(t, _r2) {
                    if (void 0 !== e.resolve || void 0 !== e.reject) throw new TypeError("Bad Promise implementation!");
                    e.resolve = t, e.reject = _r2;
                  };
                if (e.resolve = void 0, e.reject = void 0, e.promise = new t(r), !st.IsCallable(e.resolve) || !st.IsCallable(e.reject)) throw new TypeError("Bad promise constructor");
              };
            "undefined" != typeof window && st.IsCallable(window.postMessage) && (e = function e() {
              var t = [],
                e = function e(_e2) {
                  P(t, _e2), window.postMessage("zero-timeout-message", "*");
                },
                r = function r(e) {
                  if (e.source === window && "zero-timeout-message" === e.data) {
                    if (e.stopPropagation(), 0 === t.length) return;
                    _(t)();
                  }
                };
              return window.addEventListener("message", r, !0), e;
            });
            var i,
              a,
              c = st.IsCallable(T.setImmediate) ? T.setImmediate : "object" == typeof o && o.nextTick ? o.nextTick : function () {
                var t = T.Promise,
                  e = t && t.resolve && t.resolve();
                return e && function (t) {
                  return e.then(t);
                };
              }() || (st.IsCallable(e) ? e() : function (e) {
                t(e, 0);
              }),
              u = function u(t) {
                return t;
              },
              s = function s(t) {
                throw t;
              },
              f = {},
              l = function l(t, e, r) {
                c(function () {
                  p(t, e, r);
                });
              },
              p = function p(t, e, r) {
                var n, o;
                if (e === f) return t(r);
                try {
                  n = t(r), o = e.resolve;
                } catch (t) {
                  n = t, o = e.reject;
                }
                o(n);
              },
              h = function h(t, e) {
                var r = t._promise,
                  n = r.reactionLength;
                if (n > 0 && (l(r.fulfillReactionHandler0, r.reactionCapability0, e), r.fulfillReactionHandler0 = void 0, r.rejectReactions0 = void 0, r.reactionCapability0 = void 0, n > 1)) for (var o = 1, i = 0; n > o; o++, i += 3) l(r[i + 0], r[i + 2], e), t[i + 0] = void 0, t[i + 1] = void 0, t[i + 2] = void 0;
                r.result = e, r.state = 1, r.reactionLength = 0;
              },
              y = function y(t, e) {
                var r = t._promise,
                  n = r.reactionLength;
                if (n > 0 && (l(r.rejectReactionHandler0, r.reactionCapability0, e), r.fulfillReactionHandler0 = void 0, r.rejectReactions0 = void 0, r.reactionCapability0 = void 0, n > 1)) for (var o = 1, i = 0; n > o; o++, i += 3) l(r[i + 1], r[i + 2], e), t[i + 0] = void 0, t[i + 1] = void 0, t[i + 2] = void 0;
                r.result = e, r.state = 2, r.reactionLength = 0;
              },
              v = function v(t) {
                var e = !1;
                return {
                  resolve: function resolve(r) {
                    var n;
                    if (!e) {
                      if (e = !0, r === t) return y(t, new TypeError("Self resolution"));
                      if (!st.TypeIsObject(r)) return h(t, r);
                      try {
                        n = r.then;
                      } catch (e) {
                        return y(t, e);
                      }
                      if (!st.IsCallable(n)) return h(t, r);
                      c(function () {
                        d(t, r, n);
                      });
                    }
                  },
                  reject: function reject(r) {
                    if (!e) return e = !0, y(t, r);
                  }
                };
              },
              b = function b(t, e, n, o) {
                t === a ? r(t, e, n, o, f) : r(t, e, n, o);
              },
              d = function d(t, e, r) {
                var n = v(t),
                  o = n.resolve,
                  i = n.reject;
                try {
                  b(r, e, o, i);
                } catch (t) {
                  i(t);
                }
              },
              w = function () {
                var _t5 = function t(e) {
                  if (!(this instanceof _t5)) throw new TypeError('Constructor Promise requires "new"');
                  if (this && this._promise) throw new TypeError("Bad construction");
                  if (!st.IsCallable(e)) throw new TypeError("not a valid resolver");
                  var r = _t(this, _t5, i, {
                      _promise: {
                        result: void 0,
                        state: 0,
                        reactionLength: 0,
                        fulfillReactionHandler0: void 0,
                        rejectReactionHandler0: void 0,
                        reactionCapability0: void 0
                      }
                    }),
                    n = v(r),
                    o = n.reject;
                  try {
                    e(n.resolve, o);
                  } catch (t) {
                    o(t);
                  }
                  return r;
                };
                return _t5;
              }();
            i = w.prototype;
            var m = function m(t, e, r, n) {
                var o = !1;
                return function (i) {
                  if (!o && (o = !0, e[t] = i, 0 == --n.count)) {
                    (0, r.resolve)(e);
                  }
                };
              },
              O = function O(t, e, r) {
                for (var n, o, i = t.iterator, a = [], c = {
                    count: 1
                  }, u = 0;;) {
                  try {
                    if (!1 === (n = st.IteratorStep(i))) {
                      t.done = !0;
                      break;
                    }
                    o = n.value;
                  } catch (e) {
                    throw t.done = !0, e;
                  }
                  a[u] = void 0;
                  var s = e.resolve(o),
                    f = m(u, a, r, c);
                  c.count += 1, b(s.then, s, f, r.reject), u += 1;
                }
                if (0 == --c.count) {
                  (0, r.resolve)(a);
                }
                return r.promise;
              },
              j = function j(t, e, r) {
                for (var n, o, i, a = t.iterator;;) {
                  try {
                    if (!1 === (n = st.IteratorStep(a))) {
                      t.done = !0;
                      break;
                    }
                    o = n.value;
                  } catch (e) {
                    throw t.done = !0, e;
                  }
                  i = e.resolve(o), b(i.then, i, r.resolve, r.reject);
                }
                return r.promise;
              };
            return g(w, {
              all: function all(t) {
                var e = this;
                if (!st.TypeIsObject(e)) throw new TypeError("Promise is not object");
                var r,
                  o,
                  i = new n(e);
                try {
                  return r = st.GetIterator(t), o = {
                    iterator: r,
                    done: !1
                  }, O(o, e, i);
                } catch (t) {
                  var a = t;
                  if (o && !o.done) try {
                    st.IteratorClose(r, !0);
                  } catch (t) {
                    a = t;
                  }
                  var c = i.reject;
                  return c(a), i.promise;
                }
              },
              race: function race(t) {
                var e = this;
                if (!st.TypeIsObject(e)) throw new TypeError("Promise is not object");
                var r,
                  o,
                  i = new n(e);
                try {
                  return r = st.GetIterator(t), o = {
                    iterator: r,
                    done: !1
                  }, j(o, e, i);
                } catch (t) {
                  var a = t;
                  if (o && !o.done) try {
                    st.IteratorClose(r, !0);
                  } catch (t) {
                    a = t;
                  }
                  var c = i.reject;
                  return c(a), i.promise;
                }
              },
              reject: function reject(t) {
                var e = this;
                if (!st.TypeIsObject(e)) throw new TypeError("Bad promise constructor");
                var r = new n(e);
                return (0, r.reject)(t), r.promise;
              },
              resolve: function resolve(t) {
                var e = this;
                if (!st.TypeIsObject(e)) throw new TypeError("Bad promise constructor");
                if (st.IsPromise(t)) {
                  var r = t.constructor;
                  if (r === e) return t;
                }
                var o = new n(e);
                return (0, o.resolve)(t), o.promise;
              }
            }), g(i, {
              catch: function _catch(t) {
                return this.then(null, t);
              },
              then: function then(t, e) {
                var r = this;
                if (!st.IsPromise(r)) throw new TypeError("not a promise");
                var o,
                  i = st.SpeciesConstructor(r, w);
                o = arguments.length > 2 && arguments[2] === f && i === w ? f : new n(i);
                var a,
                  c = st.IsCallable(t) ? t : u,
                  p = st.IsCallable(e) ? e : s,
                  h = r._promise;
                if (0 === h.state) {
                  if (0 === h.reactionLength) h.fulfillReactionHandler0 = c, h.rejectReactionHandler0 = p, h.reactionCapability0 = o;else {
                    var y = 3 * (h.reactionLength - 1);
                    h[y + 0] = c, h[y + 1] = p, h[y + 2] = o;
                  }
                  h.reactionLength += 1;
                } else if (1 === h.state) a = h.result, l(c, o, a);else {
                  if (2 !== h.state) throw new TypeError("unexpected Promise state");
                  a = h.result, l(p, o, a);
                }
                return o.promise;
              }
            }), f = new n(w), a = i.then, w;
          }
        }();
        if (T.Promise && (delete T.Promise.accept, delete T.Promise.defer, delete T.Promise.prototype.chain), "function" == typeof yr) {
          g(T, {
            Promise: yr
          });
          var vr = j(T.Promise, function (t) {
              return t.resolve(42).then(function () {}) instanceof t;
            }),
            br = !c(function () {
              T.Promise.reject(42).then(null, 5).then(null, z);
            }),
            gr = c(function () {
              T.Promise.call(3, z);
            }),
            dr = function (t) {
              var e = t.resolve(5);
              e.constructor = {};
              var r = t.resolve(e);
              try {
                r.then(null, z).then(null, z);
              } catch (t) {
                return !0;
              }
              return e === r;
            }(T.Promise),
            wr = f && function () {
              var t = 0,
                e = Object.defineProperty({}, "then", {
                  get: function get() {
                    t += 1;
                  }
                });
              return Promise.resolve(e), 1 === t;
            }(),
            mr = function t(e) {
              var r = new Promise(e);
              e(3, function () {}), this.then = r.then, this.constructor = t;
            };
          mr.prototype = Promise.prototype, mr.all = Promise.all;
          var Or = u(function () {
            return !!mr.all([1, 2]);
          });
          if (vr && br && gr && !dr && wr && !Or || (Promise = yr, rt(T, "Promise", yr)), 1 !== Promise.all.length) {
            var jr = Promise.all;
            rt(Promise, "all", function (t) {
              return st.Call(jr, this, arguments);
            });
          }
          if (1 !== Promise.race.length) {
            var Tr = Promise.race;
            rt(Promise, "race", function (t) {
              return st.Call(Tr, this, arguments);
            });
          }
          if (1 !== Promise.resolve.length) {
            var Sr = Promise.resolve;
            rt(Promise, "resolve", function (t) {
              return st.Call(Sr, this, arguments);
            });
          }
          if (1 !== Promise.reject.length) {
            var Ir = Promise.reject;
            rt(Promise, "reject", function (t) {
              return st.Call(Ir, this, arguments);
            });
          }
          we(Promise, "all"), we(Promise, "race"), we(Promise, "resolve"), we(Promise, "reject"), Mt(Promise);
        }
        var Er = function Er(t) {
            var e = a(h(t, function (t, e) {
              return t[e] = !0, t;
            }, {}));
            return t.join(":") === e.join(":");
          },
          Mr = Er(["z", "a", "bb"]),
          Cr = Er(["z", 1, "a", "3", 2]);
        if (f) {
          var Pr = function Pr(t, e) {
              return e || Mr ? ut(t) ? "^" + st.ToString(t) : "string" == typeof t ? "$" + t : "number" == typeof t ? Cr ? t : "n" + t : "boolean" == typeof t ? "b" + t : null : null;
            },
            xr = function xr() {
              return Object.create ? Object.create(null) : {};
            },
            _r = function _r(t, e, n) {
              if (i(n) || et.string(n)) p(n, function (t) {
                if (!st.TypeIsObject(t)) throw new TypeError("Iterator value " + t + " is not an entry object");
                e.set(t[0], t[1]);
              });else if (n instanceof t) r(t.prototype.forEach, n, function (t, r) {
                e.set(r, t);
              });else {
                var o, a;
                if (!ut(n)) {
                  if (a = e.set, !st.IsCallable(a)) throw new TypeError("bad map");
                  o = st.GetIterator(n);
                }
                if (void 0 !== o) for (;;) {
                  var c = st.IteratorStep(o);
                  if (!1 === c) break;
                  var u = c.value;
                  try {
                    if (!st.TypeIsObject(u)) throw new TypeError("Iterator value " + u + " is not an entry object");
                    r(a, e, u[0], u[1]);
                  } catch (t) {
                    throw st.IteratorClose(o, !0), t;
                  }
                }
              }
            },
            Ar = function Ar(t, e, n) {
              if (i(n) || et.string(n)) p(n, function (t) {
                e.add(t);
              });else if (n instanceof t) r(t.prototype.forEach, n, function (t) {
                e.add(t);
              });else {
                var o, a;
                if (!ut(n)) {
                  if (a = e.add, !st.IsCallable(a)) throw new TypeError("bad set");
                  o = st.GetIterator(n);
                }
                if (void 0 !== o) for (;;) {
                  var c = st.IteratorStep(o);
                  if (!1 === c) break;
                  var u = c.value;
                  try {
                    r(a, e, u);
                  } catch (t) {
                    throw st.IteratorClose(o, !0), t;
                  }
                }
              }
            },
            Nr = {
              Map: function () {
                var t = {},
                  e = function e(t, _e3) {
                    this.key = t, this.value = _e3, this.next = null, this.prev = null;
                  };
                e.prototype.isRemoved = function () {
                  return this.key === t;
                };
                var n = function n(t) {
                    return !!t._es6map;
                  },
                  o = function o(t, e) {
                    if (!st.TypeIsObject(t) || !n(t)) throw new TypeError("Method Map.prototype." + e + " called on incompatible receiver " + st.ToString(t));
                  },
                  i = function i(t, e) {
                    o(t, "[[MapIterator]]"), this.head = t._head, this.i = this.head, this.kind = e;
                  };
                i.prototype = {
                  next: function next() {
                    var t = this.i,
                      e = this.kind,
                      r = this.head;
                    if (void 0 === this.i) return Vt();
                    for (; t.isRemoved() && t !== r;) t = t.prev;
                    for (var n; t.next !== r;) if (t = t.next, !t.isRemoved()) return n = "key" === e ? t.key : "value" === e ? t.value : [t.key, t.value], this.i = t, Vt(n);
                    return this.i = void 0, Vt();
                  }
                }, Ct(i.prototype);
                var a,
                  c = function t() {
                    if (!(this instanceof t)) throw new TypeError('Constructor Map requires "new"');
                    if (this && this._es6map) throw new TypeError("Bad construction");
                    var r = _t(this, t, a, {
                        _es6map: !0,
                        _head: null,
                        _map: G ? new G() : null,
                        _size: 0,
                        _storage: xr()
                      }),
                      n = new e(null, null);
                    return n.next = n.prev = n, r._head = n, arguments.length > 0 && _r(t, r, arguments[0]), r;
                  };
                return a = c.prototype, m.getter(a, "size", function () {
                  if (void 0 === this._size) throw new TypeError("size method called on incompatible Map");
                  return this._size;
                }), g(a, {
                  get: function get(t) {
                    o(this, "get");
                    var e,
                      r = Pr(t, !0);
                    if (null !== r) return e = this._storage[r], e ? e.value : void 0;
                    if (this._map) return e = W.call(this._map, t), e ? e.value : void 0;
                    for (var n = this._head, i = n; (i = i.next) !== n;) if (st.SameValueZero(i.key, t)) return i.value;
                  },
                  has: function has(t) {
                    o(this, "has");
                    var e = Pr(t, !0);
                    if (null !== e) return void 0 !== this._storage[e];
                    if (this._map) return H.call(this._map, t);
                    for (var r = this._head, n = r; (n = n.next) !== r;) if (st.SameValueZero(n.key, t)) return !0;
                    return !1;
                  },
                  set: function set(t, r) {
                    o(this, "set");
                    var n,
                      i = this._head,
                      a = i,
                      c = Pr(t, !0);
                    if (null !== c) {
                      if (void 0 !== this._storage[c]) return this._storage[c].value = r, this;
                      n = this._storage[c] = new e(t, r), a = i.prev;
                    } else this._map && (H.call(this._map, t) ? W.call(this._map, t).value = r : (n = new e(t, r), V.call(this._map, t, n), a = i.prev));
                    for (; (a = a.next) !== i;) if (st.SameValueZero(a.key, t)) return a.value = r, this;
                    return n = n || new e(t, r), st.SameValue(-0, t) && (n.key = 0), n.next = this._head, n.prev = this._head.prev, n.prev.next = n, n.next.prev = n, this._size += 1, this;
                  },
                  delete: function _delete(e) {
                    o(this, "delete");
                    var r = this._head,
                      n = r,
                      i = Pr(e, !0);
                    if (null !== i) {
                      if (void 0 === this._storage[i]) return !1;
                      n = this._storage[i].prev, delete this._storage[i];
                    } else if (this._map) {
                      if (!H.call(this._map, e)) return !1;
                      n = W.call(this._map, e).prev, q.call(this._map, e);
                    }
                    for (; (n = n.next) !== r;) if (st.SameValueZero(n.key, e)) return n.key = t, n.value = t, n.prev.next = n.next, n.next.prev = n.prev, this._size -= 1, !0;
                    return !1;
                  },
                  clear: function clear() {
                    o(this, "clear"), this._map = G ? new G() : null, this._size = 0, this._storage = xr();
                    for (var e = this._head, r = e, n = r.next; (r = n) !== e;) r.key = t, r.value = t, n = r.next, r.next = r.prev = e;
                    e.next = e.prev = e;
                  },
                  keys: function keys() {
                    return o(this, "keys"), new i(this, "key");
                  },
                  values: function values() {
                    return o(this, "values"), new i(this, "value");
                  },
                  entries: function entries() {
                    return o(this, "entries"), new i(this, "key+value");
                  },
                  forEach: function forEach(t) {
                    o(this, "forEach");
                    for (var e = arguments.length > 1 ? arguments[1] : null, n = this.entries(), i = n.next(); !i.done; i = n.next()) e ? r(t, e, i.value[1], i.value[0], this) : t(i.value[1], i.value[0], this);
                  }
                }), Ct(a, a.entries), c;
              }(),
              Set: function () {
                var t,
                  e = function e(t) {
                    return t._es6set && void 0 !== t._storage;
                  },
                  n = function n(t, r) {
                    if (!st.TypeIsObject(t) || !e(t)) throw new TypeError("Set.prototype." + r + " called on incompatible receiver " + st.ToString(t));
                  },
                  o = function e() {
                    if (!(this instanceof e)) throw new TypeError('Constructor Set requires "new"');
                    if (this && this._es6set) throw new TypeError("Bad construction");
                    var r = _t(this, e, t, {
                      _es6set: !0,
                      "[[SetData]]": null,
                      _storage: xr()
                    });
                    if (!r._es6set) throw new TypeError("bad set");
                    return arguments.length > 0 && Ar(e, r, arguments[0]), r;
                  };
                t = o.prototype;
                var i = function i(t) {
                    var e = t;
                    if ("^null" === e) return null;
                    if ("^undefined" !== e) {
                      var r = e.charAt(0);
                      return "$" === r ? C(e, 1) : "n" === r ? +C(e, 1) : "b" === r ? "btrue" === e : +e;
                    }
                  },
                  c = function c(t) {
                    if (!t["[[SetData]]"]) {
                      var e = new Nr.Map();
                      t["[[SetData]]"] = e, p(a(t._storage), function (t) {
                        var r = i(t);
                        e.set(r, r);
                      }), t["[[SetData]]"] = e;
                    }
                    t._storage = null;
                  };
                return m.getter(o.prototype, "size", function () {
                  return n(this, "size"), this._storage ? a(this._storage).length : (c(this), this["[[SetData]]"].size);
                }), g(o.prototype, {
                  has: function has(t) {
                    n(this, "has");
                    var e;
                    return this._storage && null !== (e = Pr(t)) ? !!this._storage[e] : (c(this), this["[[SetData]]"].has(t));
                  },
                  add: function add(t) {
                    n(this, "add");
                    var e;
                    return this._storage && null !== (e = Pr(t)) ? (this._storage[e] = !0, this) : (c(this), this["[[SetData]]"].set(t, t), this);
                  },
                  delete: function _delete(t) {
                    n(this, "delete");
                    var e;
                    if (this._storage && null !== (e = Pr(t))) {
                      var r = F(this._storage, e);
                      return delete this._storage[e] && r;
                    }
                    return c(this), this["[[SetData]]"].delete(t);
                  },
                  clear: function clear() {
                    n(this, "clear"), this._storage && (this._storage = xr()), this["[[SetData]]"] && this["[[SetData]]"].clear();
                  },
                  values: function values() {
                    return n(this, "values"), c(this), this["[[SetData]]"].values();
                  },
                  entries: function entries() {
                    return n(this, "entries"), c(this), this["[[SetData]]"].entries();
                  },
                  forEach: function forEach(t) {
                    n(this, "forEach");
                    var e = arguments.length > 1 ? arguments[1] : null,
                      o = this;
                    c(o), this["[[SetData]]"].forEach(function (n, i) {
                      e ? r(t, e, i, i, o) : t(i, i, o);
                    });
                  }
                }), b(o.prototype, "keys", o.prototype.values, !0), Ct(o.prototype, o.prototype.values), o;
              }()
            };
          if (T.Map || T.Set) {
            u(function () {
              return 2 === new Map([[1, 2]]).get(1);
            }) || (T.Map = function t() {
              if (!(this instanceof t)) throw new TypeError('Constructor Map requires "new"');
              var e = new G();
              return arguments.length > 0 && _r(t, e, arguments[0]), delete e.constructor, Object.setPrototypeOf(e, T.Map.prototype), e;
            }, T.Map.prototype = O(G.prototype), b(T.Map.prototype, "constructor", T.Map, !0), m.preserveToString(T.Map, G));
            var Rr = new Map(),
              kr = function () {
                var t = new Map([[1, 0], [2, 0], [3, 0], [4, 0]]);
                return t.set(-0, t), t.get(0) === t && t.get(-0) === t && t.has(0) && t.has(-0);
              }(),
              Br = Rr.set(1, 2) === Rr;
            kr && Br || rt(Map.prototype, "set", function (t, e) {
              return r(V, this, 0 === t ? 0 : t, e), this;
            }), kr || (g(Map.prototype, {
              get: function get(t) {
                return r(W, this, 0 === t ? 0 : t);
              },
              has: function has(t) {
                return r(H, this, 0 === t ? 0 : t);
              }
            }, !0), m.preserveToString(Map.prototype.get, W), m.preserveToString(Map.prototype.has, H));
            var Dr = new Set(),
              Lr = function (t) {
                return t.delete(0), t.add(-0), !t.has(0);
              }(Dr),
              Fr = Dr.add(1) === Dr;
            if (!Lr || !Fr) {
              var zr = Set.prototype.add;
              Set.prototype.add = function (t) {
                return r(zr, this, 0 === t ? 0 : t), this;
              }, m.preserveToString(Set.prototype.add, zr);
            }
            if (!Lr) {
              var Gr = Set.prototype.has;
              Set.prototype.has = function (t) {
                return r(Gr, this, 0 === t ? 0 : t);
              }, m.preserveToString(Set.prototype.has, Gr);
              var qr = Set.prototype.delete;
              Set.prototype.delete = function (t) {
                return r(qr, this, 0 === t ? 0 : t);
              }, m.preserveToString(Set.prototype.delete, qr);
            }
            var Wr = j(T.Map, function (t) {
                var e = new t([]);
                return e.set(42, 42), e instanceof t;
              }),
              Hr = Object.setPrototypeOf && !Wr,
              Vr = function () {
                try {
                  return !(T.Map() instanceof T.Map);
                } catch (t) {
                  return t instanceof TypeError;
                }
              }();
            0 === T.Map.length && !Hr && Vr || (T.Map = function t() {
              if (!(this instanceof t)) throw new TypeError('Constructor Map requires "new"');
              var e = new G();
              return arguments.length > 0 && _r(t, e, arguments[0]), delete e.constructor, Object.setPrototypeOf(e, t.prototype), e;
            }, T.Map.prototype = G.prototype, b(T.Map.prototype, "constructor", T.Map, !0), m.preserveToString(T.Map, G));
            var Ur = j(T.Set, function (t) {
                var e = new t([]);
                return e.add(42, 42), e instanceof t;
              }),
              $r = Object.setPrototypeOf && !Ur,
              Xr = function () {
                try {
                  return !(T.Set() instanceof T.Set);
                } catch (t) {
                  return t instanceof TypeError;
                }
              }();
            if (0 !== T.Set.length || $r || !Xr) {
              var Jr = T.Set;
              T.Set = function t() {
                if (!(this instanceof t)) throw new TypeError('Constructor Set requires "new"');
                var e = new Jr();
                return arguments.length > 0 && Ar(t, e, arguments[0]), delete e.constructor, Object.setPrototypeOf(e, t.prototype), e;
              }, T.Set.prototype = Jr.prototype, b(T.Set.prototype, "constructor", T.Set, !0), m.preserveToString(T.Set, Jr);
            }
            var Yr = new T.Map(),
              Zr = !u(function () {
                return Yr.keys().next().done;
              });
            if (("function" != typeof T.Map.prototype.clear || 0 !== new T.Set().size || 0 !== Yr.size || "function" != typeof T.Map.prototype.keys || "function" != typeof T.Set.prototype.keys || "function" != typeof T.Map.prototype.forEach || "function" != typeof T.Set.prototype.forEach || s(T.Map) || s(T.Set) || "function" != typeof Yr.keys().next || Zr || !Wr) && g(T, {
              Map: Nr.Map,
              Set: Nr.Set
            }, !0), T.Set.prototype.keys !== T.Set.prototype.values && b(T.Set.prototype, "keys", T.Set.prototype.values, !0), Ct(Object.getPrototypeOf(new T.Map().keys())), Ct(Object.getPrototypeOf(new T.Set().keys())), l && "has" !== T.Set.prototype.has.name) {
              var Kr = T.Set.prototype.has;
              rt(T.Set.prototype, "has", function (t) {
                return r(Kr, this, t);
              });
            }
          }
          g(T, Nr), Mt(T.Map), Mt(T.Set);
        }
        var Qr = function Qr(t) {
            if (!st.TypeIsObject(t)) throw new TypeError("target must be an object");
          },
          tn = {
            apply: function apply() {
              return st.Call(st.Call, null, arguments);
            },
            construct: function construct(t, e) {
              if (!st.IsConstructor(t)) throw new TypeError("First argument must be a constructor.");
              var r = arguments.length > 2 ? arguments[2] : t;
              if (!st.IsConstructor(r)) throw new TypeError("new.target must be a constructor.");
              return st.Construct(t, e, r, "internal");
            },
            deleteProperty: function deleteProperty(t, e) {
              if (Qr(t), f) {
                var r = Object.getOwnPropertyDescriptor(t, e);
                if (r && !r.configurable) return !1;
              }
              return delete t[e];
            },
            has: function has(t, e) {
              return Qr(t), e in t;
            }
          };
        Object.getOwnPropertyNames && Object.assign(tn, {
          ownKeys: function ownKeys(t) {
            Qr(t);
            var e = Object.getOwnPropertyNames(t);
            return st.IsCallable(Object.getOwnPropertySymbols) && x(e, Object.getOwnPropertySymbols(t)), e;
          }
        });
        var en = function en(t) {
          return !c(t);
        };
        if (Object.preventExtensions && Object.assign(tn, {
          isExtensible: function isExtensible(t) {
            return Qr(t), Object.isExtensible(t);
          },
          preventExtensions: function preventExtensions(t) {
            return Qr(t), en(function () {
              Object.preventExtensions(t);
            });
          }
        }), f) {
          var _rn = function rn(t, e, r) {
              var n = Object.getOwnPropertyDescriptor(t, e);
              if (!n) {
                var o = Object.getPrototypeOf(t);
                if (null === o) return;
                return _rn(o, e, r);
              }
              return "value" in n ? n.value : n.get ? st.Call(n.get, r) : void 0;
            },
            _nn = function nn(t, e, n, o) {
              var i = Object.getOwnPropertyDescriptor(t, e);
              if (!i) {
                var a = Object.getPrototypeOf(t);
                if (null !== a) return _nn(a, e, n, o);
                i = {
                  value: void 0,
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
                };
              }
              if ("value" in i) {
                if (!i.writable) return !1;
                if (!st.TypeIsObject(o)) return !1;
                return Object.getOwnPropertyDescriptor(o, e) ? it.defineProperty(o, e, {
                  value: n
                }) : it.defineProperty(o, e, {
                  value: n,
                  writable: !0,
                  enumerable: !0,
                  configurable: !0
                });
              }
              return !!i.set && (r(i.set, o, n), !0);
            };
          Object.assign(tn, {
            defineProperty: function defineProperty(t, e, r) {
              return Qr(t), en(function () {
                Object.defineProperty(t, e, r);
              });
            },
            getOwnPropertyDescriptor: function getOwnPropertyDescriptor(t, e) {
              return Qr(t), Object.getOwnPropertyDescriptor(t, e);
            },
            get: function get(t, e) {
              return Qr(t), _rn(t, e, arguments.length > 2 ? arguments[2] : t);
            },
            set: function set(t, e, r) {
              return Qr(t), _nn(t, e, r, arguments.length > 3 ? arguments[3] : t);
            }
          });
        }
        if (Object.getPrototypeOf) {
          var on = Object.getPrototypeOf;
          tn.getPrototypeOf = function (t) {
            return Qr(t), on(t);
          };
        }
        if (Object.setPrototypeOf && tn.getPrototypeOf) {
          var an = function an(t, e) {
            for (var r = e; r;) {
              if (t === r) return !0;
              r = tn.getPrototypeOf(r);
            }
            return !1;
          };
          Object.assign(tn, {
            setPrototypeOf: function setPrototypeOf(t, e) {
              if (Qr(t), null !== e && !st.TypeIsObject(e)) throw new TypeError("proto must be an object or null");
              return e === it.getPrototypeOf(t) || !(it.isExtensible && !it.isExtensible(t)) && !an(t, e) && (Object.setPrototypeOf(t, e), !0);
            }
          });
        }
        var cn = function cn(t, e) {
          if (st.IsCallable(T.Reflect[t])) {
            u(function () {
              return T.Reflect[t](1), T.Reflect[t](NaN), T.Reflect[t](!0), !0;
            }) && rt(T.Reflect, t, e);
          } else b(T.Reflect, t, e);
        };
        Object.keys(tn).forEach(function (t) {
          cn(t, tn[t]);
        });
        var un = T.Reflect.getPrototypeOf;
        if (l && un && "getPrototypeOf" !== un.name && rt(T.Reflect, "getPrototypeOf", function (t) {
          return r(un, T.Reflect, t);
        }), T.Reflect.setPrototypeOf && u(function () {
          return T.Reflect.setPrototypeOf(1, {}), !0;
        }) && rt(T.Reflect, "setPrototypeOf", tn.setPrototypeOf), T.Reflect.defineProperty && (u(function () {
          var t = !T.Reflect.defineProperty(1, "test", {
              value: 1
            }),
            e = "function" != typeof Object.preventExtensions || !T.Reflect.defineProperty(Object.preventExtensions({}), "test", {});
          return t && e;
        }) || rt(T.Reflect, "defineProperty", tn.defineProperty)), T.Reflect.construct && (u(function () {
          var t = function t() {};
          return T.Reflect.construct(function () {}, [], t) instanceof t;
        }) || rt(T.Reflect, "construct", tn.construct)), new Date(NaN) + "" != "Invalid Date") {
          var sn = Date.prototype.toString,
            fn = function fn() {
              var t = +this;
              return t !== t ? "Invalid Date" : st.Call(sn, this);
            };
          rt(Date.prototype, "toString", fn);
        }
        var ln = {
          anchor: function anchor(t) {
            return st.CreateHTML(this, "a", "name", t);
          },
          big: function big() {
            return st.CreateHTML(this, "big", "", "");
          },
          blink: function blink() {
            return st.CreateHTML(this, "blink", "", "");
          },
          bold: function bold() {
            return st.CreateHTML(this, "b", "", "");
          },
          fixed: function fixed() {
            return st.CreateHTML(this, "tt", "", "");
          },
          fontcolor: function fontcolor(t) {
            return st.CreateHTML(this, "font", "color", t);
          },
          fontsize: function fontsize(t) {
            return st.CreateHTML(this, "font", "size", t);
          },
          italics: function italics() {
            return st.CreateHTML(this, "i", "", "");
          },
          link: function link(t) {
            return st.CreateHTML(this, "a", "href", t);
          },
          small: function small() {
            return st.CreateHTML(this, "small", "", "");
          },
          strike: function strike() {
            return st.CreateHTML(this, "strike", "", "");
          },
          sub: function sub() {
            return st.CreateHTML(this, "sub", "", "");
          },
          sup: function sup() {
            return st.CreateHTML(this, "sup", "", "");
          }
        };
        p(Object.keys(ln), function (t) {
          var e = String.prototype[t],
            n = !1;
          if (st.IsCallable(e)) {
            var o = r(e, "", ' " '),
              i = M([], o.match(/"/g)).length;
            n = o !== o.toLowerCase() || i > 2;
          } else n = !0;
          n && rt(String.prototype, t, ln[t]);
        });
        var pn = function () {
            if (!nt) return !1;
            var t = "object" == typeof JSON && "function" == typeof JSON.stringify ? JSON.stringify : null;
            if (!t) return !1;
            if (void 0 !== t(U())) return !0;
            if ("[null]" !== t([U()])) return !0;
            var e = {
              a: U()
            };
            return e[U()] = !0, "{}" !== t(e);
          }(),
          hn = u(function () {
            return !nt || "{}" === JSON.stringify(Object(U())) && "[{}]" === JSON.stringify([Object(U())]);
          });
        if (pn || !hn) {
          var yn = JSON.stringify;
          rt(JSON, "stringify", function (t) {
            if ("symbol" != typeof t) {
              var e;
              arguments.length > 1 && (e = arguments[1]);
              var n = [t];
              if (i(e)) n.push(e);else {
                var o = st.IsCallable(e) ? e : null;
                n.push(function (t, e) {
                  var n = o ? r(o, this, t, e) : e;
                  if ("symbol" != typeof n) return et.symbol(n) ? Oe({})(n) : n;
                });
              }
              return arguments.length > 2 && n.push(arguments[2]), yn.apply(this, n);
            }
          });
        }
        return T;
      });
    }).call(e, r(2), r(3));
  }, function (t, e) {
    var r;
    r = function () {
      return this;
    }();
    try {
      r = r || Function("return this")() || (0, eval)("this");
    } catch (t) {
      "object" == typeof window && (r = window);
    }
    t.exports = r;
  }, function (t, e) {
    function r() {
      throw Error("setTimeout has not been defined");
    }
    function n() {
      throw Error("clearTimeout has not been defined");
    }
    function o(t) {
      if (f === setTimeout) return setTimeout(t, 0);
      if ((f === r || !f) && setTimeout) return f = setTimeout, setTimeout(t, 0);
      try {
        return f(t, 0);
      } catch (e) {
        try {
          return f.call(null, t, 0);
        } catch (e) {
          return f.call(this, t, 0);
        }
      }
    }
    function i(t) {
      if (l === clearTimeout) return clearTimeout(t);
      if ((l === n || !l) && clearTimeout) return l = clearTimeout, clearTimeout(t);
      try {
        return l(t);
      } catch (e) {
        try {
          return l.call(null, t);
        } catch (e) {
          return l.call(this, t);
        }
      }
    }
    function a() {
      v && h && (v = !1, h.length ? y = h.concat(y) : b = -1, y.length && c());
    }
    function c() {
      if (!v) {
        var t = o(a);
        v = !0;
        for (var e = y.length; e;) {
          for (h = y, y = []; ++b < e;) h && h[b].run();
          b = -1, e = y.length;
        }
        h = null, v = !1, i(t);
      }
    }
    function u(t, e) {
      this.fun = t, this.array = e;
    }
    function s() {}
    var f,
      l,
      p = t.exports = {};
    !function () {
      try {
        f = "function" == typeof setTimeout ? setTimeout : r;
      } catch (t) {
        f = r;
      }
      try {
        l = "function" == typeof clearTimeout ? clearTimeout : n;
      } catch (t) {
        l = n;
      }
    }();
    var h,
      y = [],
      v = !1,
      b = -1;
    p.nextTick = function (t) {
      var e = Array(arguments.length - 1);
      if (arguments.length > 1) for (var r = 1; arguments.length > r; r++) e[r - 1] = arguments[r];
      y.push(new u(t, e)), 1 !== y.length || v || o(c);
    }, u.prototype.run = function () {
      this.fun.apply(null, this.array);
    }, p.title = "browser", p.browser = !0, p.env = {}, p.argv = [], p.version = "", p.versions = {}, p.on = s, p.addListener = s, p.once = s, p.off = s, p.removeListener = s, p.removeAllListeners = s, p.emit = s, p.prependListener = s, p.prependOnceListener = s, p.listeners = function (t) {
      return [];
    }, p.binding = function (t) {
      throw Error("process.binding is not supported");
    }, p.cwd = function () {
      return "/";
    }, p.chdir = function (t) {
      throw Error("process.chdir is not supported");
    }, p.umask = function () {
      return 0;
    };
  }, function (t, e, r) {
    "use strict";

    var n = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
      return typeof t;
    } : function (t) {
      return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    };
    window.BrowsingModeDetector = function () {
      var t,
        e,
        r,
        n,
        i = this,
        a = !0;
      this.BROWSING_NORMAL_MODE = "NORMAL_MODE", this.BROWSING_INCOGNITO_PRIVATE_MODE = "INCOGNITO_PRIVATE_MODE", this.ignoringBots = function () {
        return a = !0, this;
      }, this.notIgnoringBots = function () {
        return a = !1, this;
      }, this.getBrowsingMode = function () {
        return t ? this.BROWSING_INCOGNITO_PRIVATE_MODE : this.BROWSING_NORMAL_MODE;
      }, this.setBrowsingInIncognitoMode = function () {
        t = !0;
      }, this.setBrowsingInNormalMode = function () {
        t = !1;
      }, this.isBotBrowsing = function (t) {
        var e = window.navigator.userAgent,
          r = /googlebot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis/i.test(e);
        return void 0 === t ? r : t(r);
      }, this.setCallbackForNormalMode = function (t) {
        return e = t, this;
      }, this.setCallbackForIncognitoOrPrivateMode = function (t) {
        return r = t, this;
      }, this.do = function (e) {
        if (c(e), a && this.isBotBrowsing()) return t = !1, void u();
        new o().browser(this).detectBrowsingMode(u);
      };
      var c = function c(t) {
          if ("function" != typeof (n = t) && ("function" != typeof e || "function" != typeof r)) throw "Default callback or specific callbacks are required";
        },
        u = function u() {
          t && "function" == typeof r ? r(i) : t || "function" != typeof e || e(i), void 0 !== n && n(t, i);
        };
      return this;
    };
    var o = function o() {
        var t;
        this.browser = function (r) {
          return "object" === (void 0 === t ? "undefined" : n(t)) ? t : t = e(r);
        };
        var e = function e(t) {
          return window.webkitRequestFileSystem ? new i(t) : "MozAppearance" in document.documentElement.style ? new a(t) : /constructor/i.test(window.HTMLElement) ? new c(t) : window.PointerEvent || window.MSPointerEvent ? new u(t) : new s(t);
        };
        return this;
      },
      i = function i(t) {
        return this.BrowsingModeDetector = t, this.detectBrowsingMode = function (t) {
          var e = this,
            r = function r() {
              e.BrowsingModeDetector.setBrowsingInNormalMode(), t();
            },
            n = function n() {
              e.BrowsingModeDetector.setBrowsingInIncognitoMode(), t();
            };
          window.webkitRequestFileSystem(window.TEMPORARY, 1, r, n);
        }, this;
      },
      a = function a(t) {
        return this.BrowsingModeDetector = t, this.detectBrowsingMode = function (t) {
          navigator.serviceWorker ? this.BrowsingModeDetector.setBrowsingInNormalMode() : this.BrowsingModeDetector.setBrowsingInIncognitoMode(), t();
        }, this;
      },
      c = function c(t) {
        return this.BrowsingModeDetector = t, this.detectBrowsingMode = function (t) {
          try {
            window.openDatabase(null, null, null, null);
          } catch (e) {
            this.BrowsingModeDetector.setBrowsingInIncognitoMode(), t();
          }
          try {
            localStorage.length || (localStorage.i = 1, localStorage.removeItem("i")), this.BrowsingModeDetector.setBrowsingInNormalMode();
          } catch (t) {
            navigator.cookieEnabled ? this.BrowsingModeDetector.setBrowsingInIncognitoMode() : this.BrowsingModeDetector.setBrowsingInNormalMode();
          }
          t();
        }, this;
      },
      u = function u(t) {
        return this.BrowsingModeDetector = t, this.detectBrowsingMode = function (t) {
          window.indexedDB ? this.BrowsingModeDetector.setBrowsingInNormalMode() : this.BrowsingModeDetector.setBrowsingInIncognitoMode(), t();
        }, this;
      },
      s = function s(t) {
        return this.BrowsingModeDetector = t, this.detectBrowsingMode = function (t) {
          this.BrowsingModeDetector.setBrowsingInNormalMode(), t();
        }, this;
      };
  }]);
});